export const fontFamilies = {
  Roboto: 'Roboto, sans-serif',
  Arbutus: 'Arbutus Slab, serif',
}
